import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { bindActionCreators } from "redux";
import { userFarmDetail } from "../../../config/farmDetails";
import { harvestYearDetail } from "../../../config/harvestYearDetail";
import { createCounterPartyAction } from "../../../modules/counterparties/action";
import { validForm } from "../../FormElement/FormValidator";
import CounterpartyForm from "./CounterpartyForm";

class CreateCounterparty extends Component {
  constructor(props) {
    super(props);

    this.state = {
      counterPartyInfo: {
        farmId: userFarmDetail().id || props.MainFarmId,
        name: "",
        typeId: "",
        phoneNumber: "",
        harvestYear: harvestYearDetail().name
      },
      formErrors: {
        name: "",
        typeId: ""
      },
      isValid: true,
      successMessage: "",
      errorMessage: {},
      edited: false
    };
  }

  componentDidUpdate = () => {
    if (this.state.edited) {
      window.onbeforeunload = () => true;
    } else {
      window.onbeforeunload = undefined;
    }
  };

  componentWillUnmount() {
    window.onbeforeunload = undefined;
  }

  handleChange = event => {
    if (!this.state.edited) this.setState({ edited: true });
    const { name, value } = event.target;
    if (name === "phoneNumber") {
      if (value.match(/^\d{0,15}?$/)) {
        this.updateState(name, value);
      }
    } else if (name === "name") {
      if (value.match(/^(\w|\ ){0,51}$/)) {
        this.updateState(name, value);
      }
    } else {
      this.updateState(name, value);
    }
  };

  updateState = (name, value) => {
    this.setState(
      prevState => {
        return {
          counterPartyInfo: {
            ...prevState.counterPartyInfo,
            [name]: value
          }
        };
      },
      () => {
        const { counterPartyInfo } = this.state;
        this.setState({
          isValid: validForm(this.state.formErrors, counterPartyInfo)
        });
      }
    );
  };

  handleError = (name, error) => {
    this.setState(
      prevState => {
        return {
          formErrors: {
            ...prevState.formErrors,
            [name]: error
          }
        };
      },
      () => {
        const { counterPartyInfo } = this.state;
        this.setState({
          isValid: validForm(this.state.formErrors, counterPartyInfo)
        });
      }
    );
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.partyCreated && nextProps.partyCreated.status === 200) {
      this.setState({ successMessage: true });
    }
  }

  createCounterparty = e => {
    e.preventDefault();
    const { counterPartyInfo, isValid } = this.state;
    counterPartyInfo.farmId = userFarmDetail().id || this.props.MainFarmId;
    counterPartyInfo.harvestYear = harvestYearDetail().name;
    this.setState({ isValid: true, edited: false });
    this.props.createCounterPartyAction(counterPartyInfo);
  };

  render() {
    const { successMessage, counterPartyInfo, isValid, edited } = this.state;
    if (successMessage) {
      return <Redirect to="/farmsetup/counterparties" />;
    }

    return (
      <CounterpartyForm
        buttonLabel="Add new counterpart"
        formLabel="Set up your counterpart"
        counterPartyInfo={counterPartyInfo}
        handleChange={this.handleChange}
        handleError={this.handleError}
        createCounterparty={this.createCounterparty}
        isValid={isValid}
        edited={edited}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    partyCreated: state.counterPartyReducer.partyCreated,
    MainFarmId: state.FarmManagementReducer.MainFarmId
  };
}

const mapDispatchToProps = dispatch =>
  bindActionCreators({ createCounterPartyAction }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateCounterparty);



// WEBPACK FOOTER //
// ./src/components/private/Counterparties/CreateCounterparty.js